export class FiltrosRepFinanzas{
   
    Usuario : string ='';
    Estado: string = '';
    Tipo: string = 'operaciones_estado';
    Moneda:string = '';
    Proveedor:string = '';
    Adquirente:string = '';
    Producto:string='';
   idEmpresa: string = '4';
 }